import { Box, Typography } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { handleAiAssistantIcon } from "../../../FroalaEditor/children/FroalaHelpers";
import ReactDOM from "react-dom";
import NewAIPrompt from "../../../NewAiPrompt";
import { useFormikContext } from "formik";
import FormikFroalaTextEditor from "../../../FroalaEditor/children/FormikFroalaTextEditor";
import MediaSelection from "../../../SegmentBuilder/Shared/MediaSelection";
import UploadedMedia from "../../../SegmentBuilder/Shared/UploadedMedia";
import { colors } from "../../../../utils";
import { isVideoUrl } from "../../../../utils/validations";
import Dropdown from "../../../Dropdown";
import TextView from "../../../TextView";

const AddDetailsForm = ({
  showErrors = false,
  bBoxSetter,
  isWheelBusinessBox,
}) => {
  const { values, setFieldValue, errors, dirty } = useFormikContext();

  const editorRef = useRef(null);
  const editorRef2 = useRef(null);

  const [showAiPrompt, setShowAiPrompt] = useState(false);
  const [currentCompletionType, setCurrentCompletionType] = useState("general");
  // possible values : img (0) and vid (1)
  const [mediaMode, setMediaMode] = useState(
    isVideoUrl(values.media_url) ? 1 : 0
  );

  const [originImage, setOriginImage] = useState(null);
  const [media, setMedia] = useState(values.media_url);
  const [mediaCheckFlag, setMediaCheckFlag] = useState(false);
  //remember the previous media url
  const [prevMedia, setPrevMedia] = useState("");

  const handleFroalaCustomization = (FroalaEditor) => {
    handleAiAssistantIcon(FroalaEditor, setShowAiPrompt, (editorId) => {
      // Set completion type based on which editor the AI assistant was clicked from
      let completionType = "general";
      switch (editorId) {
        case 1:
          completionType = "title";
          break;
        case 2:
          completionType = "description";
          break;
        default:
          completionType = "general";
      }
      setCurrentCompletionType(completionType);
    });
  };

  const handleMediaChange = (type, file, changeOrigin) => {
    setMedia(file?.src);
    setFieldValue("media_url", file?.src);
    changeOrigin && setOriginImage(file?.src);
  };

  const handleEmbedURLChange = (value) => {
    // Check if the URL is a video
    if (isVideoUrl(value)) {
      setMediaMode(1); // Set to video
    } else {
      setMediaMode(0); // Set to image
    }
  };

  const handleDeleteMedia = () => {
    setMedia("");
    setFieldValue("media_url", "");
    bBoxSetter((prev) => ({ ...prev, media_url: "" }));
  };

  useEffect(() => {
    if (!originImage) {
      setOriginImage(values.media_url);
    }
    setMedia(values.media_url);
    setMediaMode(isVideoUrl(values.media_url) ? 1 : 0);
  }, [values.media_url]);

  return (
    <Box sx={{}}>
      <FormikFroalaTextEditor
        editorHeight={"110px"}
        name={"business_title"}
        id={1}
        //onChange={handleTitleChange}
        handleEditorCustomization={handleFroalaCustomization}
        customDefaultFontSize={"20"}
        editorRef={editorRef}
        label={"title"}
        toolbarButtons={[
          "fontSize",
          "fontFamily",
          "textColorCustom",
          "bold",
          "italic",
          "underline",
          "aiAssistant",
        ]}
        type="business_title"
        characters="100"
        popupPositionMode="relative"
        dataEditorId="1"
      />

      {showErrors ? (
        <Typography mt={1} color={colors.error}>
          {errors.business_title}
        </Typography>
      ) : null}

      <FormikFroalaTextEditor
        editorHeight={"65px"}
        name={"description"}
        id={2}
        //onChange={handleDescriptionChange}
        handleEditorCustomization={handleFroalaCustomization}
        editorRef={editorRef2}
        label={"Description"}
        toolbarButtons={[
          "fontFamily",
          "textColorCustom",
          "bold",
          "italic",
          "underline",
          "aiAssistant",
        ]}
        type="Description"
        isExpandable={true}
        popupPositionMode="relative"
        dataEditorId="2"
      />

      {showErrors && (
        <Typography mt={1} color={colors.error}>
          {errors.description}
        </Typography>
      )}

      <Box
        display={"flex"}
        alignItems={"center"}
        justifyContent={"space-between"}
        my={2}
      >
        <TextView variant="subtitle">Image / Video</TextView>
        <Dropdown
          variant="outlined"
          value={mediaMode}
          options={[
            {
              label: "Image",
              value: "0",
            },
            {
              label: "Video",
              value: "1",
            },
          ]}
          onChange={(e) => {
            const newMode = parseInt(e.target.value);
            setMediaMode(newMode);
            setMedia("");
          }}
          style={{ width: 80 }}
        />
      </Box>

      {media && (
        <UploadedMedia
          type={mediaMode === 1 ? "video" : "image"}
          originalImage={mediaMode === 0 ? originImage : null}
          media={media}
          onChange={(val) => console.log(val)}
          title={values.media_url.split("/").pop()}
          isTitleCustomizable={false}
          handleCheckbox={
            mediaMode === 0 ? () => console.log("showImageTitle") : null
          }
          handleEditMedia={
            mediaMode === 0 ? (value) => handleMediaChange(null, value) : null
          }
          lockedAspectRatio={mediaMode === 0 ? 4 / 3 : null}
          persistCrop
          handleMediaRemove={handleDeleteMedia}
          pathType={"bussinessBox"}
        />
      )}

      <MediaSelection
        type={mediaMode === 1 ? "video" : "image"}
        handleChange={(type, file) => handleMediaChange(type, file, true)}
        isBussinessBox={true}
        showRecentDropdown={isWheelBusinessBox ? true : false}
        onEmbedURLChange={(value) => handleEmbedURLChange(value)}
        defaultEmbedValue={media}
      />

      {showAiPrompt &&
        ReactDOM.createPortal(
          <div
            style={{
              position: "fixed",
              zIndex: 6522299,
              right: "35vw",
              top: "25vh",
              overflow: "auto",
            }}
          >
            <NewAIPrompt
              modalWidth="350px"
              completionType={currentCompletionType}
              onCloseIconPress={() => setShowAiPrompt(false)}
            />
          </div>,
          document.body // You can also use a different element if needed
        )}
    </Box>
  );
};

export default AddDetailsForm;
